
<template>
    <div style="padding-bottom: 248px;padding-top: 20px;">
        <div class="container " style="background-color: #fff;padding: 38px 50px;">
            <el-button type="text" link @click="$router.go(-1);" class="btnReturn " style="padding:0 0 38px 0;margin-left: 0;">
             <div class="flx-center">
                <img style="width: 18px;height: 18px;margin-right: 5px;" :src="$ossUrl+'icons/returnOrder.png'" alt=""/>
                <span  style="color: black;font-size: 18px;line-height: 18px;">返回</span>
             </div>
          </el-button>
          <div v-for="(item,index) in questionList" :key="index" >
            <div v-if="item.id===id&&item.activeName===activeName" class="faq-item ">
                <div class="question-main-title">{{ item.main_title }}</div>
                <div class="question-main-content faq-answer flx-align-only-start" >
                  <i>答</i>
                  <div>{{ item.main_content }}</div>
                </div>
            </div>
          </div>

          
        </div> 
      </div>
</template>
<script>
export default {
name:"questionDetail",
components: {
 
  // Switcher
},
created() {
console.log(this.$route.query.id,this.$route.query.activeName,'this.$route.query.activeName')
  this.id = this.$route.query.id
  this.activeName = this.$route.query.activeName
},
data() {
  return {
    id:'',
    activeName:'',
    questionList: [
      { 
        activeName:'first',
        id:'1',
        main_title:"【入仓】为什么货物不能正常入仓？",
        main_content:"可能是以下问题之一：1、是到FBA的货物，但外箱没有FBA标签；2、外箱没有九方的运单标签；3、纸箱已经散架；4、下单信息和交货信息有出入；5、货物到仓了却还未下单。"
      },
      { 
        activeName:'first',
        id:'2',
        main_title:"【签约】什么样的物流合同才算是公平公正的合同？",
        main_content:"1、把报价表中没有但却很重要的内容都放进去的合同；2、双方把出现最坏情况的权责利都事先约定好的合同。"
      },
      { 
        activeName:'first',
        id:'3',
        main_title:"【签约】物流合同对走包税渠道的重要性？",
        main_content:"绝大部分包税货物的提单收货人都不是货主，也就是从交货给物流公司那一刻起货权就已经完全转移到了物流公司。比如货值100万，就相当于你把100万现金给了物流公司，而且连收据都不要一张。"
      },
      { 
        activeName:'first',
        id:'4',
        main_title:"【报价】如何避免隐形收费？",
        main_content:"不要追求绝对意义上的“一口价”，跨境物流始终存在一些产生额外费用的概率，只是这些额外费用是可以被事先约定清楚的。"
      },
      { 
        activeName:'first',
        id:'5',
        main_title:"【报价】报价表内容那么多，如何避免掉坑？",
        main_content:"除了运费单价，一定要注意看备注信息，重点包括价格有效期，适应的产品品类、计费方式、附加费清单、可能产生的额外费用等。"
      },
      { 
        activeName:'first',
        id:'6',
        main_title:"【报价】如何才能一次性报出准确优惠的价格？",
        main_content:"尽量一次性给出完整的货物信息，包括：整票货物的品名、体积、重量、件数、最终派送地址等。货物信息越详尽，报价越快越准。"
      },
      { 
        activeName:'second',
        id:'1',
        main_title:"【国内报关】品牌申报，我们发的不是什么知名品牌，为什么也要申报？",
        main_content:"品牌申报是海关对于货物申报的一项基本要求，跟这个品牌是否知名没有关系。如该品牌在海关有过备案（一般会带R和TM标识），报关时还需提供品牌授权书；如无海关备案，不需提供品牌授权书，如实申报品牌即可。"
      },
      { 
        activeName:'second',
        id:'2',
        main_title:"【清关】什么叫一般贸易出口报关,我公司没有进出口权我的货物是怎么出去的？",
        main_content:"我国的出口贸易方式有很多种，常见的包括：一般贸易/来料加工/旅游购物/保税仓储/租赁贸易/跨境电商（B2C项下）等等。对于FBA头程物流的出口，基本归属于一般贸易报关方式（代号0110）的范畴，也叫正式报关出口。申报单位需向海关提交：出口货物报关单；报关委托书；销售合同；装箱单；发票等整套单证。大部分中小卖家不具备进出口权，也不具备出口退税的条件，为了方便快捷，通常做法是购买别的进出口企业的核销单以别的进出口企业的名义出口，业内称之为“代理出口”。"
      },
      { 
        activeName:'second',
        id:'3',
        main_title:"【VAT申报】英国VAT申报中，C79和C88有什么区别？",
        main_content:"C79是每个月进口报税的汇总，海关会在次月寄信件到注册VAT时提供的通信地址；C88是每一次进口清关的税单，由清关的报关行可以拿到；季度申报时，税局要求提供C79进行申报。"
      },
      { 
        activeName:'second',
        id:'4',
        main_title:"【关税】如何查询亚马逊各站点所在国的产品进口关税税率？",
        main_content:"欧洲产品进口关税查询：http://ec.europa.eu;美国产品进口关税查询：https://hts.usitc.gov;加拿大产品进口关税查询：http://www.cbsa-asfc.gc.ca;日本产品进口关税查询：http://www.customs.go.jp;澳洲产品进口关税查询：https://ftaportal.dfat.gov.au"
      },
      { 
        activeName:'second',
        id:'5',
        main_title:"【海关】如何理解产品的海关编码（HS Code），编码归类的主要依据是什么？",
        main_content:"海关编码其实是依据《商品名称及编码协调制度的国际公约》（简称HS），用科学系统的方法将商品分类。HS采用六位数编码，把全部国际贸易商品分为22类，98章。章以下再分为目和子目。商品编码第一、二位数码代表“章”，第三、四位数码代表“目”（Heading），第五、六位数码代表“子目”（Subheading）。前6位数是HS国际标准编码，后2-4位数是各个国家海关按照实际情况再进行延伸，所以大家才会常说前6位海关编码是国际通用的。"
      },
      { 
        activeName:'second',
        id:'6',
        main_title:"【头程物流】DDP与DDU分别是什么意思？",
        main_content:"DDP即完税后交货，通俗的理解为出口商在起运港预付了税金（包含关税和VAT等）；DDU即未完税交货，可理解为由进口商在目的港缴税。FBA头程运输中，如果卖家在国外没有自己的公司或银行账户来及时缴税，则需要通过物流公司来做DDP条款的完税交货（注意：亚马逊不能作为进口商，不会为卖家缴税）。"
      },
      { 
        activeName:'third',
        id:'1',
        main_title:"【海运】海运整箱运输时效性如何？",
        main_content:"我司在美国、加拿大、日本、英国、德国、法国、意大利、西班牙八个国家航线均有长期合作的船公司，全部提供港到港时效最快的直航船，有多个船公司的多条航线随时根据客户的货期安排不同的船期。"
      },
      { 
        activeName:'third',
        id:'2',
        main_title:"【空运】美国空运安排什么时候航班？",
        main_content:"交货后的航班安排，我司已经有固定的航班安排，固定每周三/六的航班，起飞后，第二天到港。"
      },
      { 
        activeName:'third',
        id:'3',
        main_title:"【国际快递】货物交由DHL,UPS,FED,TNT转运途中，能否直接申请更改地址或者退运？",
        main_content:"不能；只能转运到目的国清关后，尝试申请更改或退运，会有相关费用产生。"
      },
      { 
        activeName:'third',
        id:'4',
        main_title:"【空运】FEDEX追踪单号什么时候生成?",
        main_content:"FEDEX追踪单号在货物交至我司后即可生成，美国清关放行后即可上网查询转运轨迹"
      },
      { 
        activeName:'fourth',
        id:'1',
        main_title:"【海运】货到港后清关方面有什么需要注意？清关时效怎样？",
        main_content:"接到客户订单以后，我们专业客服同事会根据目的港代理提供的参考范围替客户审核发票金额，避免到港后目的港海关对发票金额提出异议重新审核而耽误清关时间。我司在以上八个目的港国家均有专业资质、经验丰富的报关行及时代理清关，保证及时有效的清关时效。"
      },
      { 
        activeName:'fourth',
        id:'2',
        main_title:"【签约】什么样的物流合同才算是公平公正的合同？",
        main_content:"1、把报价表中没有但却很重要的内容都放进去的合同；2、双方把出现最坏情况的权责利都事先约定好的合同；"
      },
      { 
        activeName:'fourth',
        id:'3',
        main_title:"【国际快递】非亚马逊的货物，是否还需要做DDP出货？",
        main_content:"收件方是直接收件人的，没有要求必须做预付还是到付，可以自由选择。"
      },
      { 
        activeName:'fourth',
        id:'4',
        main_title:"【欧洲专线】自由税号怎么清关？税单出来要多长时间？",
        main_content:"客户自有税号我们单票清关，单票出税单，税单显示客户的税号，单票小于1000KG的我们选择快递派送，单票大约1000KG的我们选择卡车派送。税单出来的时间为1-2个月。"
      },
      { 
        activeName:'fourth',
        id:'5',
        main_title:"【清关】清关会需要收件人协助吗？",
        main_content:"一般不需要，我司会统一安排清关。"
      },
      { 
        activeName:'fourth',
        id:'6',
        main_title:"【清关】欧洲哪些类别的产品清关会有特殊要求？",
        main_content:"根据我司多年欧洲的清关经验，手机、自行车及其配件、纺织品、鞋子、蓝牙产品、电器类大件产品、部分LED产品清关会有特殊要求（关税较高或有反倾销税或需要提供认证证书），具体发货前请咨询我司客服人员。"
      },
      { 
        activeName:'five',
        id:'1',
        main_title:"【转运】我们是亚马逊的VE供货商，仓库能不能接受亚马逊到仓提货呢？",
        main_content:"可以，目前美国两个仓库都可以接受VE自提。"
      },
      { 
        activeName:'five',
        id:'2',
        main_title:"【转运】亚马逊分配FBA地址大多在美国中东部地区，从美西的仓库发过去距离太远，运费太高，有没有解决方案？",
        main_content:"我司一直都在跟进市场的走向和亚马逊的分仓情况，这个问题我们也留意到了，所以今年我们新增了美东的中转仓服务，美西美东两个中转仓同时运转，方便各卖家根据自身货物分仓情况自主选择，更贴心的服务，真正做到帮卖家节省物流成本。"
      },
      { 
        activeName:'five',
        id:'3',
        main_title:"【转运】整柜运输的时候，能不能不打托盘？",
        main_content:"可以，但是不打托盘卸货比较麻烦，仓库需要耗费一定的人工。仓库需要耗费更多人工成本，相对的卸货费会增加。"
      },
      { 
        activeName:'five',
        id:'4',
        main_title:"【美国专线】网站显示签收后，但是一直没上架？",
        main_content:"我司专线派送是按UPS官网显示签收为准，如果派送后长时间没有上架信息，我司会提供POD给客户，以此找亚马逊开CASE查询。"
      },
      { 
        activeName:'five',
        id:'5',
        main_title:"【国际快递】货物在签收后发现破损了怎么办？",
        main_content:"如签收后有异常的，需在签收后7天内向当地服务商提出异常反馈并拿到当地受理备案号码，提交调查所需的资料，以便调查。破损件：提交当地受理备案号并提交:产品内包装，外包装图片，产品破损细节图，破损数量，重量，申报价值等调查所需资料，等候调查结果。"
      },
      { 
        activeName:'five',
        id:'6',
        main_title:"【报价】如何才能一次性报出准确优惠的价格？",
        main_content:"尽量一次性给出完整的货物信息，包括：整票货物的品名、体积、重量、件数、最终派送地址等。货物信息越详尽，报价越快越准。"
      },
      { 
        activeName:'six',
        id:'1',
        main_title:"【退货换标】为什么仓库收到的数量和亚马逊后台退货的数量不同？",
        main_content:"客观来说，亚马逊系统和人工也有可能出错，我们之前服务过两个客户，货物分别从亚马逊退到我们美国仓和英国仓，其中英国仓收到的箱子是有附带装箱清单的，但是仓库收到后马上开箱核对就发现少了一个。美国仓收到的没有清单，但是也同样比亚马逊后台纪录少了一个。因此仓库只能以实际收到的数量为准。"
      },
      { 
        activeName:'six',
        id:'2',
        main_title:"【退货换标】亚马逊后台申请移除订单，货物可能分几次退出，能不能先在仓库集齐货物再操作派送？",
        main_content:"可以，我们仓库可以根据客户的要求，先接收货物，集齐所有货物再安排操作派送，帮卖家们节省成本。"
      },
      { 
        activeName:'seven',
        id:'1',
        main_title:"【计费】亚马逊FBA仓费用怎么计算？",
        main_content:"自 2018 年 2 月 22 日起，亚马逊官方将开始按照商品体积（长 x 宽 x 高，以英寸为单位）除以 139（而不是之前的 166）这种方式来计算体积重量。体积重量仅适用于重量超过 1 磅的大号标准尺寸商品以及所有小号、中号和大号大件商品。请注意，体积重量还用于计算多渠道配送费用和库存配置服务费用。"
      },
      { 
        activeName:'seven',
        id:'2',
        main_title:"【账号注册】亚马逊全球开店需要具备什么条件？",
        main_content:"首先是个人账号所需资料，北美站： 1、电子邮箱地址；2、个人名称、地址、联系方式；3、可以支付美元的双币信用卡（Visa 等）；4、在注册期间可以联系到您的电话号码。个人卖家的月租金是39.99 美元/月。日本站：1、电子邮箱地址； 2、个人名称、地址、联系方式； 3、 国际信用卡（Visa, MasterCard 等）；4、 银行帐号信息 ；5在注册期间可以联系到你的电话号码；个人卖家的月租金是4900 日元/月。欧洲站：1、电子邮箱地址； 2、个人名称、地址、联系方式； 3、 国际信用卡（Visa, MasterCard 等）；4、 银行帐号信息 ；5在注册期间可以联系到你的电话号码；个人卖家的月租金是25 英镑/月。公司账号所需资料北美站：1、营业执照、2、VISA双币信用 卡、3、 收款账号、4、身份证。欧洲站：1、营业执照和身份证、2、法人或者 受益人承债信用卡、3、收款账户。日本站：1、营业执照和身份证、2、VISA或者JCB 双币信用卡、3、 收款账户。"
      },
      { 
        activeName:'seven',
        id:'3',
        main_title:"【亚马逊开店】在亚马逊欧洲开店，需要哪些基本费用？",
        main_content:"分个人销售及专业销售计划，“个人销售计划”会被收取按件收费的费用，而“专业销售计划”账户则需要支付月度的订阅费。个人销售计划：免月租费、 按件收费（0.75 英镑/件 ）、销售佣金（根据不同品类亚马逊收取不同比例的佣金，一般为 8%-15%）销售佣金。月租金：即亚马逊网站使用费，按月收取。"
      },
  ]
  }
},
methods: {
  
}

};
</script>
<style src="../index.css" scoped>






</style>